export default "__VITE_ASSET__DOqfrL05__"